import type { ReactNode } from "react";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "../context/AuthProvider";

interface AppProvidersProps {
    children: ReactNode;
}

// Order matters: AuthProvider may use router hooks, so it sits inside the router
const AppProviders = ({ children }: AppProvidersProps) => {
    return (
        <HelmetProvider>
            <BrowserRouter>
                <AuthProvider>{children}</AuthProvider>
            </BrowserRouter>
        </HelmetProvider>
    );
};

export default AppProviders;